import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from './api/client';
import Ornament from './components/Ornament';
import Icon from './components/Icon';
import './CandidateDashboard.css';

const CandidateDashboard = () => {
    const [appliedJobs, setAppliedJobs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const token = localStorage.getItem('token');
    const userName = localStorage.getItem('userName');
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            navigate('/signin');
            return;
        }
        const fetchAppliedJobs = async () => {
            try {
                const data = await api.get('/api/job/applied-jobs/me');
                setAppliedJobs(data || []);
            } catch (error) {
                console.error('Error fetching applied jobs:', error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchAppliedJobs();
    }, [token, navigate]);

    return (
        <div className="cd-page">

            <div className="cd-welcome">
                <Ornament variant="lotus" tone="gold" size={120} className="cd-welcome-ornament" />
                <span className="cd-welcome-eyebrow">Candidate Dashboard</span>
                <h1>Namaskāram{userName ? `, ${userName}` : ''}</h1>
                <p>Your applications and opportunity tracker.</p>
            </div>

            <div className="cd-stats">
                <div className="cd-stat">
                    <div className="cd-stat-value">{appliedJobs.length}</div>
                    <div className="cd-stat-label">Applications submitted</div>
                </div>
                <div className="cd-stat">
                    <div className="cd-stat-value">—</div>
                    <div className="cd-stat-label">Under review</div>
                </div>
                <div className="cd-stat">
                    <div className="cd-stat-value">—</div>
                    <div className="cd-stat-label">Shortlisted</div>
                </div>
            </div>

            <div className="cd-section-head">
                <div className="sw-section-mark">My applications</div>
                <button
                    className="sw-btn sw-btn-ghost sw-btn-sm"
                    onClick={() => navigate('/job-listings')}
                >
                    <span>Browse new opportunities</span>
                    <Icon name="arrow" size={14} />
                </button>
            </div>

            {isLoading ? (
                <div className="cd-empty">
                    <Ornament variant="lotus" tone="gold" size={48} />
                    <p>Loading your applications…</p>
                </div>
            ) : appliedJobs.length === 0 ? (
                <div className="cd-empty">
                    <Ornament variant="flourish" tone="gold" size={56} />
                    <h3>No applications yet</h3>
                    <p>Browse the network and apply to opportunities that fit you.</p>
                    <button
                        className="sw-btn sw-btn-saffron sw-btn-sm"
                        onClick={() => navigate('/job-listings')}
                    >
                        <span>Browse opportunities</span>
                        <Icon name="arrow" size={14} />
                    </button>
                </div>
            ) : (
                <div className="cd-grid">
                    {appliedJobs.map((job) => {
                        const primary = job.fields?.[0]?.value || 'Untitled role';
                        return (
                            <article key={job._id} className="cd-card">
                                <h3>{primary}</h3>
                                <div className="cd-card-fields">
                                    {(job.fields || []).slice(1, 3).map((field, idx) => (
                                        <div key={field._id || idx} className="cd-field">
                                            <span className="cd-field-label">{field.label}</span>
                                            <span className="cd-field-value">{field.value || '—'}</span>
                                        </div>
                                    ))}
                                </div>
                                <footer className="cd-card-foot">
                                    <span className="sw-tag sw-tag-success">
                                        <Icon name="check" size={12} /> Submitted
                                    </span>
                                    <button
                                        className="sw-btn sw-btn-ghost sw-btn-sm"
                                        onClick={() => navigate(`/job-details/${job._id}`)}
                                    >
                                        <span>View details</span>
                                        <Icon name="arrow" size={14} />
                                    </button>
                                </footer>
                            </article>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default CandidateDashboard;
